<template>
  <div class="role-form">
    <div class="wrapper">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <Title :title="`基本信息`"></Title>
          <el-form-item label="角色名称：" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述：" prop="desp">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 8}"
              v-model="ruleForm.desp"
              placeholder="请输入角色简介"
            ></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <Title :title="`权限设置`"></Title>
          <el-form-item label prop="">
            <el-row  v-for="(item,index) in power_options" :key="index">
            <el-checkbox v-model="item.default" @change="getCheck">{{item.name}}</el-checkbox>
            </el-row>
          </el-form-item>
        </el-row>

        <el-row class="tc" >
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import Title from "@/components/title";

import {_getColumnIndex,_roleEdit} from "@/api/role";

import qs from "qs";

export default {
  props: {
    formData:{
      type:Object,
      default:{}
    },
    isEdit:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    formData(val){
      for (const key in this.ruleForm) {
        this.ruleForm[key]=this.formData[key]
      }
      this.getColumnIndex();
    }
  },
  created() {
  },
  components: {
    Title,
  },
  data() {
    return {
      ruleForm: {
        name: "",
        desp: "",
        column_ids:[],
        id:'',
      },
      power_options: [],
      rules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        desp: [{ required: true, message: "请输入角色描述", trigger: "blur" }],
        type: [
          { type: 'array', required: true, message: '请至少选择一个权限设置', trigger: 'change' }
        ],
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //当前的状态
    getCheck(val){
      // console.log(this.power_options)
    },
    // 一个处理控件信息的方法
    getFormId(arr) {
      let data = [];
      arr.map(item => {
        if (item.default == true) {
          data.push(item.id);
        }
      });
      return data;
    },
    //查询数据方法
    //first--编辑的的id，second所有的数据
    getEditData(first, second) {
      first.forEach(item => {
        second.map((info, index) => {
          if (info.id == item) {
            info.default=true
          }
        });
      });
      return second;
    },
    //获取栏目数据
    getColumnIndex(){
      _getColumnIndex().then(res=>{
        if(res.resultCode==1){
          // 添加自己的信息
          let data=res.result.list.map(item=>{
              item.default=false
              return item;
          })
          console.log(data);
          //添加是否是编辑模式
          if(!this.isEdit){
            this.power_options=data;
          }else{
            console.log(this.ruleForm.column_ids)
            this.power_options=this.getEditData(this.ruleForm.column_ids,data);
            // console.log(info);
          }
        }else{
          this.$message.error(res.errorMsg);         
        }
      })
    },
    //提交信息
    submit(){
      //添加角色的时候处理数据
      this.ruleForm.column_ids=this.getFormId(this.power_options);
      // console.log(this.ruleForm)
      _roleEdit({
        data:qs.stringify(this.ruleForm)
      }).then(res=>{
        console.log(res);
        if(res.resultCode==1){
          // 添加自己的信息
          this.$message.success(res.errorMsg);
          setTimeout(() => {
            this.$router.push({ path:'/system/role'});
          }, 1000);
        }else{
          this.$message.error(res.errorMsg);
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.role-form {
  padding: 20px;
  background: #ffffff;
  .wrapper {
    max-width: 1000px;
  }
}
</style>